(function () {
    "use strict";

    angular.module("app").component("habilInvalidRemark", {
        template:
            `<div class="tab-panel bg-danger text-danger">
                <habil-invalid-remark-view remark="$ctrl.remark.Description"></habil-invalid-remark-view>

                <div class="space-above">
                    <p class="pull-left" style="margin-top: 5px;" i18n="SO_Acknowledges_ReasonToSendBack"></p>
                    &nbsp;
                    <button type="button" class="btn btn-danger" ng-click="$ctrl.Acknowledge()" i18n="Organisation_Change"></button>
                </div>
            </div>`,
        bindings: {
            owner: "=",
            remark: "=",
            onAcknowledged: "&?",
        },
        controller: HabilInvalidRemarkController
    });

    HabilInvalidRemarkController.$inject = ["controllerDecorator",];
    function HabilInvalidRemarkController(controllerDecorator) {
        const vm = this;

        controllerDecorator.Decorate(vm, []);

        vm.Acknowledge = acknowledge;

        function acknowledge() {
            if (vm.remark.IsValid === undefined) {
                acknowledgeSectionBasedRemark();
            }
            else {
                acknowledgeNewRemark();
            }            
        }

        function acknowledgeSectionBasedRemark() {
            vm.onAcknowledged({ owner: vm.owner, remark: vm.remark });
        }

        function acknowledgeNewRemark() {
            vm.SetLoadingState(true);

            vm.Api.AcknowledgeRemark(
                { Remark: vm.remark },
                (result) => {
                    if (result.data) {
                        vm.remark.IsValid = false;
                        if (angular.isFunction(vm.onAcknowledged))
                            vm.onAcknowledged({ owner: vm.owner, remark: vm.remark });
                    }
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }
    }
})();
